export const APP_URL = process.env.APP_URL;
export const APP_URL_LEGACY = process.env.APP_URL_LEGACY;
export const APP_ACCOUNT_URL = process.env.APP_ACCOUNT_URL;
export const WEBAPI_ENDPOINT = process.env.WEBAPI_ENDPOINT;
/**
 * NOTE: DON'T USE THIS FUNCTION FOR CLIENT-SIDE URL FORMATTING
 * */
export function url(pathname: string) {
  if (typeof window !== 'undefined') throw new Error('url() method should not be called within the browser.');
  let path = pathname.replace(/^\//g, '').trim();
  return `${APP_URL}/${path}`;
}

export function url_legacy(pathname: string) {
  if (typeof window !== 'undefined') throw new Error('url() method should not be called within the browser.');
  let path = pathname.replace(/^\//g, '').trim();
  return `${APP_URL_LEGACY}/${path}`;
}

export function url_webapi(pathname: string) {
  if (typeof window !== 'undefined') throw new Error('url_webapi() method should not be called within the browser.');
  let path = pathname.replace(/^\//g, '').trim();
  return `${WEBAPI_ENDPOINT}/${path}`;
}

export function url_account(pathname: string) {
  if (typeof window !== 'undefined') throw new Error('url() method should not be called within the browser.');
  let path = pathname.replace(/^\//g, '').trim();
  return `${APP_ACCOUNT_URL}/${path}`;
}

// TODO: MOVE TO BROWSER.TS
export function urlCategory(categorySlug: string, contentSlug: string) {
  if (!contentSlug || !categorySlug) {
    throw new Error('categoryUrl cannot have null values for categorySlug and contentSlug');
  }
  return `/${categorySlug}/${contentSlug}.html`;
}

// TODO: MOVE TO BROWSER.TS
export function urlPacotes(slug?: string, travelType?: string, absolute?: string) {
  if (!slug) {
    return '/pacotes';
  }

  if (travelType) {
    return `/pacotes/${slug}?travelType=${travelType}`;
  }

  return `/pacotes/${slug}`;
}

// TODO: MOVE TO BROWSER.TS
/**@deprecated Should use the browser.ts version*/
export function urlViagens(slug?: string) {
  if (!slug) {
    return '/viagens';
  }
  slug = slug.replace(/^\//, '');

  // Since migration Cruise TravelType to external feature
  if (slug === 'cruzeiros') {
    return '/cruzeiros';
  }
  return `/viagens/${slug}`;
}

export const paths = {
  csrf_token: '/proxy/form/token',
  form_create_journey: '/viagens/crie-seu-roteiro',
};
